<div class="switch-container" [class.has-error]="touched && required && !value">
  <div class="switch-wrapper" [class.label-before]="labelPosition === 'before'">
    <!-- Label before switch -->
    <label *ngIf="label && labelPosition === 'before'" [for]="id || name" class="switch-label">
      {{ label }}
      <span *ngIf="required" class="required-indicator">*</span>
    </label>

    <!-- Material Switch -->
    <mat-slide-toggle
      [id]="id || name"
      [name]="name"
      [required]="required"
      [disabled]="disabled"
      [color]="color"
      [checked]="value"
      [class]="'switch-toggle ' + class"
      (change)="onToggle()"
      (blur)="onBlur()"
    >
    </mat-slide-toggle>

    <!-- Label after switch -->
    <label *ngIf="label && labelPosition === 'after'" [for]="id || name" class="switch-label">
      {{ label }}
      <span *ngIf="required" class="required-indicator">*</span>
    </label>
  </div>

  <!-- Error message -->
  <div *ngIf="touched && required && !value" class="error-message">This field is required.</div>
</div>
